import React from 'react';

function BuzzerComponent() {
    return <div>BuzzerComponent</div>;
}

export default BuzzerComponent;
